<template>
  <layout-envelope
    :style="{
      background
    }"
    v-statusbar.hide
  >
    <top-small>
      <template v-slot:left>
        <back-button-government-home style="color:var(--interaction-dark)" />
      </template>
      <template v-slot:default>
        <navbar class="px-8" />
      </template>
    </top-small>
    <router-view></router-view>
  </layout-envelope>
</template>

<script>
import TopSmall from "@/components/layouts/TopSmall";
import BackButtonGovernmentHome from "@/components/buttons/BackButtonGovernmentHome";
import StatusBarDirective from "@/directives/StatusBarDirective";
import LayoutEnvelope from "../components/layouts/LayoutEnvelope.vue";
import Navbar from "@/components/nav/NavbarGovernment";
import { mapGetters } from "vuex";
import IsMobileMixin from "../utils/IsMobileMixin";

export default {
  name: "Judiciary",
  components: { LayoutEnvelope, TopSmall, BackButtonGovernmentHome, Navbar },
  directives: { statusbar: StatusBarDirective },
  mixins: [IsMobileMixin],
  computed: {
    ...mapGetters("location", ["canton"]),
    ...mapGetters("user", ["user"]),
    background() {
      return this.isMobileScreen
        ? "white"
        : this.canton(this.user.cantonId).backgroundGradient;
    }
  }
};
</script>

<style scoped>
.navbar-government {
  box-sizing: border-box;
  padding: 0 2.25rem;
  height: 100%;
  line-height: 1.25em;
}
.navbar-government a,
.navbar-government button {
  line-height: 1em;
  vertical-align: baseline;
}
@media screen and (min-width: 768px) {
  .navbar-government {
    padding: 0 3.7rem;
  }
}

@media (min-width: 1024px) {
  .navbar-government {
    height: fit-content;
  }
}
</style>
